import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

export const createFeatureSlice = (set: SetState<AskPerformYardState>) => ({
	hasNoDocuments: false,
	hasGoalCategories: true,
	cachedAskHrEnabled: false,
	cachedGoalCreationEnabled: false,
	cachedFormCreationEnabled: false,
	cachedCompetencyInterviewerEnabled: false,
	cachedReportBuilderEnabled: false,
	cachedIsOnFormBuilderPage: false,
	cachedGoalCoachingEnabled: false,
	cachedIsOnCompetencyPage: false,
	cachedIsOnGoalCreationPage: false,
	cachedFormBuildingCoachEnabled: false,
	isOnFormBuilderPage: false,
	isOnCompetencyPage: false,

	setHasNoDocuments: (hasNoDocuments: boolean) => set({ hasNoDocuments }),
	setHasGoalCategories: (hasGoalCategories: boolean) => set({ hasGoalCategories }),
	setIsOnFormBuilderPage: (value: boolean) => set({ isOnFormBuilderPage: value }),
	setIsOnCompetencyPage: (value: boolean) => set({ isOnCompetencyPage: value }),
});
